import type { DocNode } from '@atlaskit/adf-schema';
import { reduce } from '@atlaskit/adf-utils/traverse';

export type LinkCounts = {
	/** Total number of all links (smartLinks + regularLinks) */
	totalLinks: number;
	/** Number of smartlinks (inlineCardCount + embedCardCount) */
	smartLinkCount: number;
	/** Number of inline card smartlinks */
	inlineCardCount: number;
	/** Number of embed card smartlinks */
	embedCardCount: number;
	/** Number of regular text links (text nodes with link marks) */
	regularLinkCount: number;
};

/**
 * Traverses an ADF document and counts all link types using @atlaskit/adf-utils.
 */
export const getLinkCounts = (doc: DocNode): LinkCounts => {
	const counts = reduce<{
		inlineCardCount: number;
		embedCardCount: number;
		regularLinkCount: number;
	}>(
		doc,
		(acc, node) => {
			if (node.type === 'inlineCard') {
				acc.inlineCardCount++;
			} else if (node.type === 'embedCard') {
				acc.embedCardCount++;
			} else if (node.type === 'text' && node.marks?.some((m) => m.type === 'link')) {
				acc.regularLinkCount++;
			}
			return acc;
		},
		{ inlineCardCount: 0, embedCardCount: 0, regularLinkCount: 0 },
	);

	const smartLinkCount = counts.inlineCardCount + counts.embedCardCount;

	return {
		totalLinks: smartLinkCount + counts.regularLinkCount,
		smartLinkCount,
		inlineCardCount: counts.inlineCardCount,
		embedCardCount: counts.embedCardCount,
		regularLinkCount: counts.regularLinkCount,
	};
};
